import IGridComponent from '../../../components/grid/i-grid.component';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { AppContext } from '../../../app-context';
import { useEffect, useState, useContext } from 'react';
import { getSplit } from '../costing.services';
import { formatTo2Decimal, formatToNumberRound, isEmptyArray } from '../../common/util.services';
import { ALL, EMPTY_STRING, PAGE_SIZE } from '../../common/constants';

const SplitComponent = (props: any) => {

  const columns: GridColDef[] = [
    { field: 'customer', headerName: 'Customer', width: 210 },
    { field: 'product', headerName: 'Product', width: 210 },
    { field: 'type', headerName: 'Type', width: 100 },
    { field: 'totalCost', headerName: 'Total Cost', 
      valueFormatter: (totalCost: any) => formatToNumberRound(totalCost), width: 120
    },
    { field: 'materialCost', headerName: 'Material Cost', 
      valueFormatter: (materialCost: any) => formatToNumberRound(materialCost), width: 120
    },
    { field: 'processCost', headerName: 'Process Cost', 
      valueFormatter: (processCost: any) => formatToNumberRound(processCost), width: 120
    },
    { field: 'laborCost', headerName: 'Labor Cost', 
      valueFormatter: (laborCost: any) => formatToNumberRound(laborCost), width: 120
    },
    { field: 'materialPercent', headerName: 'Material (%)', 
      valueFormatter: (materialPercent: any) => formatTo2Decimal(materialPercent) + '%', width: 120
    },
    { field: 'processPercent', headerName: 'Process (%)', 
      valueFormatter: (processPercent: any) => formatTo2Decimal(processPercent) + '%', width: 120
    },
    { field: 'laborPercent', headerName: 'Labor (%)', 
      valueFormatter: (laborPercent: any) => formatTo2Decimal(laborPercent) + '%', width: 120
    },
  ];
  
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [split, setSplit] = useState(rows);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);
  const searchData = {costingId : props.data.rowId, 
                      searchText : props.data.searchText ? props.data.searchText : EMPTY_STRING, 
                      customer : props.data.customer ? props.data.customer : ALL, 
                      product : props.data.product ? props.data.product : ALL, 
                      type : props.data.type ? props.data.type : ALL, 
                      startDate: props.data.startDate ? props.data.startDate :props.data.creationDate,
                      endDate: props.data.endDate ? props.data.endDate :props.data.creationDate};
  
  useEffect(() => {
    if (isEmptyArray(rows)) {
      getSplit(searchData, page, pageSize, appContext,
        (response: any) => {
          setSplit(response.data.data);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
        });
      }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  return <>
    <div>
      <IGridComponent title='' showAddBtn={false} rows={split} columns={columns} getRowId={(row: any) => row.id}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows} loading={loading}/>
    </div>
  </>
}

export default SplitComponent;